import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "pedal-selection__results" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 0 }

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/userStore'
import { usePedalStore } from '@/store/pedalStore'
import {
  ListItemState,
  BfLoader,
  BfList,
  BfListItem,
  BfFlex,
  BfInput,
} from '@finetic/bikefitting-ui'
import { useDebounceFn } from '@vueuse/core'
import SelectionDetails from '@/components/setup/SelectionDetails.vue'
import SelectionDetailsItem from '@/components/setup/SelectionDetailsItem.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PedalSelection',
  emits: ['select'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const userStore = useUserStore()
const pedalStore = usePedalStore()
const { sessionId } = storeToRefs(userStore)
const { pedalData, filters } = storeToRefs(pedalStore)
const loading = ref(false)
const selected = ref()

const emit = __emit

const select = (pedal: any) => {
  selected.value = pedal
  emit('select', pedal)
}

const search = () => {
  selected.value = undefined
  loading.value = true

  pedalStore.reset()
  pedalStore.retrievePedals(sessionId?.value ?? '').then(() => {
    loading.value = false
  })
}

const updateSearch = useDebounceFn(() => {
  search()
}, 300)

search()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(BfFlex), null, {
      default: _withCtx(() => [
        _createVNode(_unref(BfInput), {
          modelValue: _unref(filters).FreeTextSearch,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).FreeTextSearch) = $event)),
          name: _unref(t)('common.search.filterBrandOrModel'),
          placeholder: _unref(t)('common.search.filterBrandOrModel'),
          style: {"flex":"1"},
          onKeyup: _unref(updateSearch)
        }, null, 8, ["modelValue", "name", "placeholder", "onKeyup"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (loading.value)
        ? (_openBlock(), _createBlock(_unref(BfLoader), { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(pedalData).length > 0)
        ? (_openBlock(), _createBlock(_unref(BfList), { key: 1 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pedalData), (pedal, i) => {
                return (_openBlock(), _createBlock(_unref(BfListItem), {
                  key: i,
                  text: `${pedal.PEDAL_BRAND} ${pedal.PEDAL_MODEL}`,
                  state: 
          pedal === selected.value ? _unref(ListItemState).Active : _unref(ListItemState).Enabled
        ,
                  onClick: ($event: any) => (select(pedal))
                }, null, 8, ["text", "state", "onClick"]))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!loading.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(t)('common.search.noResults')), 1))
              : _createCommentVNode("", true)
          ]))
    ]),
    (selected.value)
      ? (_openBlock(), _createBlock(SelectionDetails, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(SelectionDetailsItem, {
              label: _unref(t)('setup.pedal.stack'),
              value: `${selected.value.PEDAL_HEIGHT} ${_unref(t)('common.unit.mm')}`,
              icon: "/icons/filters/pedal__stack.svg"
            }, null, 8, ["label", "value"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})